module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4BYEX"))).then(() => parcelRequire('8rm4T'));